export const RENDERER_CONFIG = {
	SCENE_BACKGROUND: 0xf8f9fa,
	HELPERS_COLOR: 0x060606,
	LIGHTS_COLOR: 0xf8f9fa,
	CONTROLS: {
		PAN_SPEED: 0.8,
		SCREEN_SPACE_PANNING: false,
		ROTATE_SPEED: 10,
		ROTATE_TIME: 500,
		MIN_DISTANCE: 0.15,
		MAX_DISTANCE: 3,
	},
	CAMERA_DISTANCE_TICK: 0.5,
	DRACO_DECODER_PATH: 'https://www.gstatic.com/draco/versioned/decoders/1.5.7/',
	SELECTABLE_LAYER: 2,
	OUTLINE_PARAMS: {
		edgeStrength: 15,
		edgeGlow: 0,
		edgeThickness: 1,
		pulsePeriod: 0,
		visibleEdgeColor: 0xffffff,
		hiddenEdgeColor: 0xffffff,
	},
} as const;
